import {
  Component,
  ViewEncapsulation
} from '@angular/core';
import { GridDataBase } from '@ui/grid-view/grid-data.abstract';

@Component({
  selector: 'ui-grid-view',
  templateUrl: './grid-view.component.html',
  styleUrls: ['./grid-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GridViewComponent<T> extends GridDataBase<T> {}

export interface GridViewColumnDefinition<T = any> {
  definition: string;
  header: string;
  sortable?: boolean;
  tooltip?: boolean;
  ellipsis?: boolean;

  display(row: T): any;
}
